@if (!!isRulesetEmpty()) {
  <div class="p-[18px] rounded-md border-1 flex justify-between items-center mb-1" style="border: 1px solid #444444">
    <span class="font-bold">{{ IP_RULE_TYPE_NAMES[displayRulesetObj()?.rule_type] || 'Default Rule' }}</span>
    <div class="custom-switch mr-8">
      <p-toggleSwitch [ngModel]="displayRulesetObj().enabled" (onChange)="onSwitchChange($event, $event.originalEvent)" />
    </div>
  </div>
} @else {
  <p-accordion-panel [value]="accordionIndex()">
    <p-accordion-header>
      <div class="flex flex-row w-full justify-between items-center">
        <span>{{ IP_RULE_TYPE_NAMES[displayRulesetObj()?.rule_type] || 'Rule' }}</span>
        <div class="custom-switch mr-4">
          <p-toggleSwitch [ngModel]="displayRulesetObj().enabled" (onChange)="onSwitchChange($event, $event.originalEvent)" />
        </div>
      </div>
    </p-accordion-header>
    <p-accordion-content>
      <div class="w-full p-3">
        <microsec-common-toolbar #ct [configuration]="filterConfiguration" [filterObject]="filterObject" [leftTemplate]="null" />
      </div>
      <div class="grid grid-cols-12">
        <div class="col-span-12">
          <microsec-card [isNestedCard]="true" [isTableCard]="true">
            <microsec-common-table
              #dt
              [cols]="rulesetCols"
              [values]="displayRulesetObj().rule_sets"
              [scrollHeight]="'35rem'"
              [showContainerHeader]="true"
              [containerHeaderRightTemplate]="rulesetObj()?.rule_type === IP_RULE_TYPES.CUSTOM ? containerRightTemplate : undefined"
              [cellTemplate]="cellTemplate"
              [actionsMenuItems]="rulesetObj()?.rule_type === IP_RULE_TYPES.CUSTOM ? customActionsItems : undefined">
            </microsec-common-table>
          </microsec-card>
        </div>
      </div>
    </p-accordion-content>
  </p-accordion-panel>
}

<ng-template #containerRightTemplate>
  <p-button
    type="button"
    icon="fa fa-plus"
    severity="success"
    size="small"
    pTooltip="Add Custom Rules"
    tooltipPosition="bottom"
    appendTo="body"
    (onClick)="openCustomForm()"></p-button>
</ng-template>

<ng-template let-col="col" let-rowData="rowData" let-index="index" #cellTemplate>
  <ng-container [ngSwitch]="col.field">
    <ng-container *ngSwitchCase="'enabled'">
      <p-toggleSwitch [ngModel]="rowData[col.field]" (onChange)="onRowDataSwitchChange($event, $event.originalEvent, index)" />
    </ng-container>
    <ng-container *ngSwitchDefault>
      {{ rowData[col.field] || '-' }}
    </ng-container>
  </ng-container>
</ng-template>
